module.exports = __webpack_public_path__ + "static/img/zz_als.a4006acf.png";